import { render, staticRenderFns } from "./ev5-swiper-video.vue?vue&type=template&id=dbaae1b0&scoped=true&"
import script from "./ev5-swiper-video.vue?vue&type=script&lang=js&"
export * from "./ev5-swiper-video.vue?vue&type=script&lang=js&"
import style0 from "./ev5-swiper-video.vue?vue&type=style&index=0&id=dbaae1b0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbaae1b0",
  null
  
)

export default component.exports